import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from '../locales/en/translation.json';

export const defaultNS = 'translation';
export const resources = {
  en: {
    translation,
  },
} as const;

i18n.use(initReactI18next).init({
  resources,
  defaultNS,
  ns: Object.keys(resources.en),
  lng: 'en',
  interpolation: {
    escapeValue: false, // not needed for react
  },
  react: {
    useSuspense: true,
  },
});

export default i18n;
